import script from "./CreditReportInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreditReportInformation.vue?vue&type=script&setup=true&lang=ts"

import "./CreditReportInformation.vue?vue&type=style&index=0&id=a5fbcaf4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5fbcaf4"]])

export default __exports__